import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, ReactiveFormsModule, FormGroup, Validators, FormArrayName, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute,  } from '@angular/router';
import { RefControllerService } from '../services/ref-controller.service';
import { AutheticationControllerService } from '../services/authetication-controller.service';
import { StudentTestControllerService } from '../services/student-test-controller.service';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-history-log',
  templateUrl: './history-log.component.html',
  styleUrls: ['./history-log.component.css']
})
export class HistoryLogComponent {

  public loading = false;
  informWindow = false;

  iin: any;
  applicationList: any;
  hoverOnStudent = 0;
  student: any;
  seasonDto: any;
  id: any;
  testStatusDto: any;
  lastname: any;
  firstname: any;
  patronymic: any;
  createdAt: any;
  phoneNumber: any;
  testOrgDto: any;
  jobDto: any;
  appTypeDto: any;
  langDto: any;
  jobTypeDto: any;
  studentDto: any;
  email: any;
  startTestTime: any;
  testDate: any;
  testPeriodDto: any;
  oblDto: any;
  employmentTypeDto: any;

  form!: FormGroup;

  constructor(
    private autheticationControllerService: AutheticationControllerService,
    private refControllerService: RefControllerService,
    public route: ActivatedRoute,
    public router: Router,
    private studentTest: StudentTestControllerService,
    public translate: TranslateService,
    private _notifications: NotificationsService) {
  }
  ngOnInit(): void {
  this.form = new FormGroup({
  iin: new FormControl()
});
}
  getFindNqtActionLogByIin(){
    this.informWindow = true;
    this.studentTest.findNqtActionLogByIin(this.form.get('iin')!.value)
      .subscribe((res: any) => {
        this.applicationList = res;
      }, (err: any) => {
        this.loading = false;
        this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', err.error.message, NotificationType.Error, 5000) :
          this._notifications.create('Қате', err.error.message, NotificationType.Error, 5000);
      });
  }
  oknoData(student: any){
    this.hoverOnStudent = student.id;
    this.seasonDto = student.seasonDto;
    this.patronymic = student.patronymic;
    this.createdAt = student.createdAt;
    this.phoneNumber = student.phoneNumber;
    this.testOrgDto = student.testOrgDto;
    this.appTypeDto = student.appTypeDto;
    this.langDto = student.langDto;
    this.iin = student.iin;
    this.studentDto = student.studentDto;
    this.email = student.email;
    this.testPeriodDto = student.testPeriodDto;
    this.lastname = student.lastName;
    this.startTestTime = student.startTestTime;
    this.testDate = student.testDate;
    this.employmentTypeDto = student.employmentTypeDto;
    this.firstname = student.firstName;
    this.patronymic = student.patronymic;
    this.oblDto = student.oblDto;
    this.jobTypeDto = student.jobTypeDto;
    this.jobDto = student.jobDto;
    this.testStatusDto = student.testStatusDto;
    // this.appTypeId = student.appTypeId;
    // this.seasonId = student.seasonId;
    // this.appType = student.appType.id;
    // this.appTypes = student.appType;
    // this.testStatus = student.testStatus;
    // this.testOrgEntity = student.testOrgEntity;
    // this.sprDisabilityEntity = student.sprDisabilityEntity;
    // this.roomPlaceNumber = student.roomPlaceNumber;
    // this.roomNumber = student.roomNumber;
    // this.sprForeignLangCertTypeEntity = student.sprForeignLangCertTypeEntity;
    // this.foreignLangCertScore = student.foreignLangCertScore;
    // this.newRoomPlace = student.newRoomPlace;
    // this.newRoomNumber = student.newRoomNumber;
    // this.transfer = student.transfer;
    // this.oldRoomNumber = student.oldRoomNumber;
    // this.oldRoomPlaceNumber = student.oldRoomPlaceNumber;
    // this.transferTime = student.transferTime;
  }
}
